export class MakeYearModel {
  make: string;
  year: string;
  model: string;
  submodel: string;
  submodelText: string;
  option: string;
  isSummerSeason: boolean;
  defaultWheelSummerStagger: string;
  defaultTireSummerStagger: string;
  defaultWheelWinterStagger: string;
  defaultTireWinterStagger: string;
  defaultAggressive: boolean;
  isConcept: boolean;
  country: string;

  constructor(mym?: MakeYearModel) {
    if (mym) {
      Object.assign(this, mym);
    } else {
      this.year = null;
      this.make = null;
      this.model = null;
      this.submodel = null;
      this.submodelText = null;
      this.option = null;
      this.defaultAggressive = false;
      this.country = null;
    }
  }

  get getYearStr(): string {
    return this.year ? this.year.toString() : null;
  }

  get isValid(): boolean {
    return (this != null && this.make != null && this.year != null && this.model != null
      && this.submodel != null && this.option != null);
  }

  public static compare(vehicle1: MakeYearModel, vehicle2: MakeYearModel): boolean {
    let equal = true;
    if (vehicle1 != null && vehicle2 != null &&
      Object.keys(vehicle1).length === Object.keys(vehicle2).length) {

      Object.keys(vehicle1).forEach(property => {
        if (vehicle1[property] !== vehicle2[property]) {
          equal = false;
          return;
        }
      });

    } else if (vehicle1 !== vehicle2) {
      equal = false;
    }

    return equal;
  }
}

export class SimpleMakeYearModel {
  make: string;
  year: string;
  model: string;
  submodel: string;
  option: string;
  isSummerSeason: boolean;
}
